import styles from "./index.module.less";
import jiantouOrange from "@/assets/lottie/jiantou_orange.json";
import jiantou from "@/assets/lottie/jiantou.json";
import Lottie from "lottie-react";
import { Flex, Space } from "antd";
import useHoverLottie from "@/hooks/useHoverLottie";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useStore } from "@/stores";
import { getProducts } from "@/constants/product";
const products = getProducts();
const subNavs2 = [
  {
    name: "企业定制服务",
    value: "enterprise",
  },
  {
    name: "OEM商业合作",
    value: "live",
  },
  {
    name: "私有化部署",
    value: "miniProgram",
  },
];
const NavItem = ({
  item,
}: {
  item: {
    name: string;
    value: string;
    icon?: string;
  };
}) => {
  const { lottieOptions, playLottieOnce, stopLottie } = useHoverLottie({
    animationData: jiantouOrange,
  });
  const location = useLocation();
  // const isActive = location.pathname.includes(item.value);
  const navigate = useNavigate();
  return (
    <div
      className={classNames(styles.sub_navs_item, {
        // [styles.active]: isActive,
      })}
      onClick={() => {
        navigate(item.value);
        // window.location.href = `/${item.value}`;
      }}
      onMouseEnter={playLottieOnce}
      onMouseLeave={stopLottie}
    >
      <img src={item.icon} className={styles.sub_navs_item_icon} />
      <div>{item.name}</div>
      <span className={styles.sub_navs_item_arrow}>
        <Lottie
          {...lottieOptions}
          className={styles.sub_navs_item_arrow_lottie}
        />
      </span>
    </div>
  );
};
const ProductSubNavs = () => {
  const {
    lottieOptions: contactLottieOptions,
    playLottieOnce: playContactLottie,
    stopLottie: stopContactLottie,
  } = useHoverLottie({
    animationData: jiantou,
  });
  const appStore = useStore("app");
  return (
    <div className={styles.sub_navs_wrap}>
      <div className={styles.sub_navs_left}>
        <div className={styles.sub_navs_title}>产品方案</div>
        <Flex>
          <div className={styles.sub_navs_list}>
            {products.slice(0, 4).map((item, i) => (
              <NavItem key={item.value} item={item} />
            ))}
          </div>
          <div className={styles.sub_navs_list} style={{marginRight: '-1.24rem'}}>
            {products.slice(4).map((item, i) => (
              <NavItem key={item.value} item={item} />
            ))}
          </div>
        </Flex>
      </div>
      <div className={styles.sub_navs_right}>
        <div className={styles.sub_navs_title}>商业合作与定制服务</div>
        <div
          className={styles.sub_navs_right_list}
          onClick={() => {
            appStore.openContactModal();
          }}
        >
          {subNavs2.map((item) => (
            <div key={item.value} className={styles.sub_navs_item}>
              {item.name}
              <span className={styles.sub_navs_item_arrow}></span>
            </div>
          ))}
          <div className={styles.sub_navs_item_divider}></div>
          <Flex
            align="center"
            justify="center"
            gap={4}
            className={styles.sub_navs_item_contact}
            onMouseEnter={playContactLottie}
            onMouseLeave={stopContactLottie}
          >
            联系我们
            <Lottie
              {...contactLottieOptions}
              className={styles.sub_navs_item_contact_arrow}
            />
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default ProductSubNavs;
